import { getQuery } from "analytics/util/helpers";

/**
 * The `cf` query param is the same value as the promo id.
 * `cf` is in the process of being deprecated by the analytics
 * but with legacy links, we're keeping the `cf` query param.
 * @param {string} product - For legacy reasons, the product was
 * not included the original query param.  So we need to append it.
 * @return {string} - The formatted query param to be utilized for analytics events.
 */
export default function formattedCameFromParam(product) {
	const cameFromParam = getQuery("cf");
	return cameFromParam ? `${product}.${cameFromParam}` : null;
}



// WEBPACK FOOTER //
// ./src/analytics/util/cameFrom.js